import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import { parseLang, type Lang } from "@majourneys/shared";
import { blogApi } from "../api/blog.api";
import { blogKeys } from "../constants/query-keys";
import type { BlogFilters } from "../constants/query-keys";

/** Blog list URL search, as both the route loader and the page read it. */
export interface BlogListSearch {
  page?: string | number;
  category?: string;
  search?: string;
}

/**
 * The one place the list filters are built from the URL, so the route loader
 * and `useBlogs` always land on the same query key.
 */
export function blogListFilters(search: BlogListSearch): BlogFilters {
  return {
    page: Number(search.page) || 1,
    category: search.category,
    search: search.search,
  };
}

export function blogListQueryOptions(lang: Lang, filters?: BlogFilters) {
  return queryOptions({
    queryKey: blogKeys.list(lang, filters),
    queryFn: () => blogApi.list(lang, filters),
  });
}

export function useBlogs(filters?: BlogFilters) {
  const { lang } = useParams({ strict: false }) as { lang?: string };
  return useSuspenseQuery(blogListQueryOptions(parseLang(lang), filters));
}
